import { render, staticRenderFns } from "./wcr.vue?vue&type=template&id=0fcb0292&scoped=true"
import script from "./wcr.vue?vue&type=script&lang=js"
export * from "./wcr.vue?vue&type=script&lang=js"
import style0 from "./wcr.vue?vue&type=style&index=0&id=0fcb0292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb0292",
  null
  
)

export default component.exports